import { createConsumer } from "@rails/actioncable"
import { API_URL } from "@/constants"

export const consumer = createConsumer(() => {
  const token = localStorage.getItem("token")
  const base = API_URL || ""
  return `${base}/cable?token=${token}`
})

// Токен подставляется в момент подключения: после смены сессии (имперсонация
// и выход из неё) соединение нужно поднять заново, иначе сервер продолжает
// считать его прежним пользователем.
export const reconnectCable = () => {
  consumer.disconnect()
  consumer.connect()
}
